import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { NestApiProvider } from "../../nest-api";
import { ResponseData } from "../../nest-responses";

@Injectable()
export class SfRequestInboxNestApi {
    private service: string = '';
    private model: string = 'sfrequestinbox';

    constructor(
        private nestApiProvider: NestApiProvider
    ) {
    }

    public closeRequest(payload: { requestNo: string[] }): Observable<ResponseData<any>> {
        const method: string = 'POST';
        const func: string = 'closeRequest';
        const params: any = payload;
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

    public getApprovalList(reqno: string, isSF6: boolean): Observable<ResponseData<any>> {
        const method: string = 'GET';
        const func: string = 'getApprovalList';
        const params: any = {};
        const urlParams: any = { reqno: reqno, isSF6: isSF6 };
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }



}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/sf-request-inbox.api.ts